<ng-template #draftColumns>
    <tr>
        <th>Nome de minuta</th>
        <th>Nome do tipo de documento</th>
        <th>Risco</th>
        <th>Última atualização</th>
        <th>Status</th>
        <th></th>
    </tr>
</ng-template>

<div class="row">
    <div class="col-12">
        <div class="dash-details-card">
            <div class="minutas-subtabs">
                <app-tabs [tabs]="subTabs" (onChangeTab)="onChangeSubTab($event)"
                    [currentTab]="subTabIndex" [dashboardTab]="true">
                </app-tabs>
            </div>

            <div class="dash-details-card-header text-right"
                *ngIf="activeSubTab === 'drafts'">
                <div></div>

                <div *ngIf="applicableRole === 'ADM'">
                    <!-- <app-button [inverted]="true" (click)="addNewDocument()" class="mr-2">
            Criar minuta
          </app-button> -->
                    <app-button (click)="openLinkModal('draft')" *ngIf="canAdd">
                        Vincular minuta
                    </app-button>
                </div>
            </div>

            <div class="dash-details-card-header text-right"
                *ngIf="activeSubTab === 'templates'">
                <div></div>

                <div class="d-flex align-items-center justify-content-end">
                    <app-button [inverted]="true" class="mr-2"
                        (onClick)="toggleFilterModal()">
                        <svg-icon src="assets/images/icon_filter.svg"
                            class="mr-2"></svg-icon>
                        {{ hasFilters ? 'Editar filtros' : 'Filtrar' }}
                    </app-button>
                    <app-button (onClick)="openLinkModal('template')">
                        Adicionar vínculo
                    </app-button>
                </div>
            </div>

            <app-spacer [bottom]="30"></app-spacer>

            <!-- Skeleton loading -->
            <ng-container *ngIf="loading">
                <table class="bordered">
                    <thead>
                        <tr>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '80px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </th>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '100px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </th>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '120px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </th>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '120px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </th>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '140px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '150px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '80px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '100px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '100px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                    height: '15px',
                                    width: '120px',
                                    marginBottom:'0'
                                }">
                                </ngx-skeleton-loader>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <app-spacer [bottom]="28"></app-spacer>
            </ng-container>

            <!-- Conteúdo real -->
            <ng-container *ngIf="!loading">
                <table class="bordered" *ngIf="data.length > 0">
                    <thead>
                        <ng-container *ngTemplateOutlet="draftColumns"></ng-container>
                    </thead>

                    <tbody>
                        <tr *ngFor="let item of data">
                            <td>{{item.name}}</td>
                            <td>{{item.documentType}}</td>
                            <td>{{item.riskLabel}}</td>
                            <td>{{formatDate(item.date_updated)}}</td>
                            <td>
                                <div class="status-tag" [ngClass]="item.statusClass">
                                    {{item.statusLabel}}
                                </div>
                            </td>
                            <td>
                                <div class="dash-card-item-buttons">
                                    <ng-container
                                        *ngIf="activeSubTab === 'drafts' && canAdd">
                                        <app-tooltip
                                            text="Enviar para assinatura"
                                            position="top">
                                            <button class="dash-item-button"
                                                (click)="sendToSignature(item)">
                                                <svg-icon
                                                    src="assets/images/icon-send.svg"></svg-icon>
                                            </button>
                                        </app-tooltip>
                                        <app-spacer [right]="16"></app-spacer>
                                        <app-tooltip text="Cancelar minuta"
                                            position="top">
                                            <button class="dash-item-button"
                                                (click)="openCancelModal(item)">
                                                <svg-icon
                                                    src="assets/images/icon-times-circle.svg"></svg-icon>
                                            </button>
                                        </app-tooltip>
                                        <app-spacer [right]="16"
                                            *ngIf="canAdd || canView"></app-spacer>
                                    </ng-container>

                                    <app-tooltip text="Desvincular"
                                        position="top" *ngIf="canAdd">
                                        <button class="dash-item-button"
                                            (click)="openUnlinkModal(item)">
                                            <svg-icon
                                                src="assets/images/icon-unlink.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                    <app-spacer [right]="16"
                                        *ngIf="canView && canAdd"></app-spacer>
                                    <app-tooltip text="Visualizar"
                                        position="top" *ngIf="canView">
                                        <button class="dash-item-button"
                                            (click)="handleOpenVisualizer(item.id)">
                                            <svg-icon
                                                src="assets/images/icon-eye.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <app-spacer [bottom]="28"></app-spacer>
                </table>

                <div *ngIf="data.length === 0" class="card-padding-bottom">
                    <app-empty-content [isVisible]="true"
                        title="Nenhum documento encontrado"
                        description="Não foi encontrado nenhum documento nesse cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>
                </div>

                <div *ngIf="data.length > 0">
                    <app-pagination [data]="data" [count]="count"
                        [show]="true" [offset]="offset"
                        (onPageChange)="changePage($event)"
                        [dashPagination]="true"
                        [resultsPerPage]="resultsPerPage">
                    </app-pagination>
                </div>
            </ng-container>
        </div>
        <app-spacer [bottom]="24"></app-spacer>
    </div>
</div>

<app-document-visualizer-modal [active]="showDocument" [file]="document"
    (onClose)="closeModal()" *ngIf="document">
</app-document-visualizer-modal>


<app-side-modal [active]="linkModal" (onClose)="toggleLinkModal(false)"
    [title]="linkModalTitle" paddingBottom="30">
    <form [formGroup]="linkForm">
        <div class="row">

            <div class="col-12">
                <app-select [items]="draftsItems" [label]="linkModalLabel"
                    [group]="linkForm" controlName="draft"
                    placeholder="Selecione">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

        </div>

        <app-spacer [bottom]="32"></app-spacer>

        <div class="row button-sticky">

            <div class="col-12">
                <div class="text-right">
                    <app-button (onClick)="submitForm()" class="add-button">
                        {{ linkModalAction }}
                    </app-button>
                </div>
            </div>

        </div>
    </form>
</app-side-modal>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    (onClose)="toggleFilterModal()" (onApply)="applyFilters()"
    (onReset)="resetFilters()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                label="Nome de minuta" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12">
            <app-select [items]="riskItems" [group]="filterForm"
                controlName="risk" label="Risco" placeholder="Selecione">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
        <div class="col-12">
            <app-select [items]="statusFilterItems" [group]="filterForm"
                controlName="status" label="Status" placeholder="Selecione">
            </app-select>
        </div>
    </div>
</app-side-filter-modal>

<app-carbon-warning-modal [active]="showUnlinkModal"
    title="Desvincular template" [message]="unlinkMessage"
    confirmText="Sim, desvincular" cancelText="Não, cancelar"
    [confirmAction]="confirmUnlink.bind(this)"
    [cancelAction]="closeUnlinkModal.bind(this)" (onClose)="closeUnlinkModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showCancelModal"
    title="Cancelar minuta" [message]="cancelMessage"
    confirmText="Sim, cancelar" cancelText="Não, manter"
    [confirmAction]="confirmCancel.bind(this)"
    [cancelAction]="closeCancelModal.bind(this)" (onClose)="closeCancelModal()">
</app-carbon-warning-modal>